/** Mapping allineato a tabella DB `stato_vendor` (id_stato_vendor → stato). */

export const VENDOR_STATO_ATTIVO = 1;
export const VENDOR_STATO_NON_ATTIVO = 2;
export const VENDOR_STATO_IN_ATTIVAZIONE = 3;
export const VENDOR_STATO_REGISTRATO = 4;
export const VENDOR_STATO_SOSPESO = 5;

export const VENDOR_STATO_FILTER_ALL = "Tutti";

const DB_STATO_OPTIONS = [
  { stato: VENDOR_STATO_ATTIVO, label: "Attivo" },
  { stato: VENDOR_STATO_NON_ATTIVO, label: "Non attivo" },
  { stato: VENDOR_STATO_IN_ATTIVAZIONE, label: "In Attivazione" },
  { stato: VENDOR_STATO_REGISTRATO, label: "Registrato" },
  { stato: VENDOR_STATO_SOSPESO, label: "Sospeso" },
];

export const formatStatoFilterValue = (label) => {
  if (label === VENDOR_STATO_FILTER_ALL) {
    return "STATO:TUTTI";
  }
  return `STATO:${label.toUpperCase()}`;
};

export const VENDOR_STATO_FILTER_OPTIONS = [
  ...DB_STATO_OPTIONS.map((option) => ({
    ...option,
    value: formatStatoFilterValue(option.label),
  })),
  {
    stato: null,
    label: VENDOR_STATO_FILTER_ALL,
    value: formatStatoFilterValue(VENDOR_STATO_FILTER_ALL),
  },
];

export const DEFAULT_VENDOR_STATO_FILTER = formatStatoFilterValue("Attivo");

export const VENDOR_STATO_FILTER_STORAGE_KEY = "cm-vendor-stato-filter";

export const loadPersistedStatoFilter = () => {
  try {
    const stored = window.sessionStorage.getItem(VENDOR_STATO_FILTER_STORAGE_KEY);
    if (stored && VENDOR_STATO_FILTER_OPTIONS.some((option) => option.value === stored)) {
      return stored;
    }
  } catch {
    // sessionStorage may be unavailable
  }
  return DEFAULT_VENDOR_STATO_FILTER;
};

export const persistStatoFilter = (filterValue) => {
  try {
    window.sessionStorage.setItem(VENDOR_STATO_FILTER_STORAGE_KEY, filterValue);
  } catch {
    // sessionStorage may be unavailable
  }
};

export const vendorStatoFilterValue = (filterValue) => {
  const match = VENDOR_STATO_FILTER_OPTIONS.find((option) => option.value === filterValue);
  if (match) {
    return match.stato;
  }
  if (filterValue === formatStatoFilterValue(VENDOR_STATO_FILTER_ALL)) {
    return null;
  }
  return VENDOR_STATO_ATTIVO;
};

export const vendorStatoLabel = (stato) => {
  if (stato == null || stato === "") {
    return "—";
  }
  const numeric = Number(stato);
  const match = DB_STATO_OPTIONS.find((option) => option.stato === numeric);
  return match?.label || String(stato);
};
